import request from '@/utils/request'

/**
 *  收银台接口
*/ 

// 批次初始接口 只用一次
export const init_getBatch=(data)=>{
    return request({
        url: '/erp/pos-goods/home',
        method: 'post',
        data
    })
}

// 分类初始接口 只用一次
export const init_getCate =(data)=>{
    return request({
        url: '/erp/pos-goods/cate',
        method: 'post',
        data
    })
}

// 获取附加费列表
export const fee_getList=(data)=>{
    return request({
        url: '/erp/pos-goods/surcharge-search',
        method: 'post',
        data
    })
}



// 买家列表
export const buyer_list=(data)=>{
    return request({
        url: '/erp/base-buyer/index',
        method: 'get',
        data
    })
}


// 买家新增 
export const buyer_create=(data)=>{
    return request({
      url: '/erp/base-buyer/edit__role',
      method: 'post',
      data
    })
}
// 买家详情 
export const buyer_detail=(data)=>{
    return request({
      url: '/erp/base-buyer/info',
      method: 'get',
      data
    })
}

// 长链接监听有没有新的数据
export const ws_url = process.env.VUE_APP_BASE_API_WS


/**
 * 商品模块
 */
export const goods_getList=(data)=>{
    return request({
      url: '/erp/pos-goods/search',
      method: 'post',
      data
    })
}

/**
 * 订单模块
 */

// 收银台创建订单
export const shop_create = (data) => {
    return request({
        url: '/erp/order-draft-main/billing',
        method: 'post',
        data
    })
}

// 收银台订单列表
export const shop_getList = (data) => {
    return request({
        url: '/erp/order-draft-main/buyer-list',
        method: 'post',
        data
    })
}

// 收银台订单详情
export const shop_getDetail = (data) => {
    return request({
        url: '/erp/order-draft-main/detail',
        method: 'post',
        data
    })
}

// 收银台订单删除
export const shop_delete = (data) => {
    return request({
        url: '/erp/order-draft-main/delete',
        method: 'post',
        data
    })
}


// 收银台订单商品新增
export const shop_goods_add = (data) => {
    return request({
        url: '/erp/order-draft-main/cash-create',
        method: 'post',
        data
    })
}

// 收银台订单商品修改
export const shop_goods_update = (data) => {
    return request({
        url: '/erp/order-draft-main/edit',
        method: 'post',
        data
    })
}

// 收银台订单商品删除
export const shop_goods_delete = (data) => {
    return request({
        url: '/erp/order-draft-main/goods-delete',
        method: 'post',
        data
    })
}


// 收银台订单商品检测
export const shop_check_delete = (data) => {
    return request({
        url: '/erp/order-draft-main/bill',
        method: 'post',
        data
    })
}

// 收银台订单支付
export const order_pay = (data) => {
    return request({
        url: '/erp/order-total/create',
        method: 'post',
        data
    })
}

// 付款扫码
export const orderPayPos = (data) => {
    return request({
        url: '/erp/order-total/order-pay',
        method: 'post',
        data
    })
}

// 查询订单结果
export const orderQueryResult = (data) => {
    return request({
        url: '/erp/order-total/order-query',
        method: 'post',
        data
    })
}


// 打印订单
export const orderPrint = (data) => {
    return request({
        url: '/erp/order-total/temp-print',
        method: 'post',
        data
    })
}
